import { createContext, useContext } from 'react';

/** The frame's CSS scale, published so gesture handlers inside it can turn
 * screen-pixel pointer deltas back into content pixels. 1 outside a frame. */
export const DeviceScaleContext = createContext(1);

export const useDeviceScale = () => useContext(DeviceScaleContext);
